import {
  SET_IS_DRAWER_OPEN,
  SET_IS_MODAL_OPEN,
  SET_TASK_ID,
  SET_ORIGIN_MODAL,
  SET_SCHEDULE_IMPACT_REQUEST_ITEMS,
  SET_SCHEDULE_IMPACT_REQUEST_ITEM,
  SET_IS_IN_PREVIEW,
  SET_ACTIVITIES_NO_APPLY_CHANGES,
  SET_REQUEST_ID
} from '../actions/scheduleImpactRequestActions';

function scheduleImpactRequestReducer(
  state = {
    isDrawerOpen: false,
    isModalOpen: false,
    taskId: null,
    originModal: null,
    scheduleImpactRequestItems: [],
    isInPreview: false,
    activitiesNoApplyChanges: [],
    requestId: null
  },
  action
) {
  switch (action.type) {
    case SET_IS_DRAWER_OPEN:
      return {
        ...state,
        isDrawerOpen: action.isDrawerOpen
      };
    case SET_IS_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: action.isModalOpen
      };
    case SET_TASK_ID:
      return {
        ...state,
        taskId: action.taskId
      };
    case SET_ORIGIN_MODAL:
      return {
        ...state,
        originModal: action.originModal
      };
    case SET_SCHEDULE_IMPACT_REQUEST_ITEMS:
      return {
        ...state,
        scheduleImpactRequestItems: action.scheduleImpactRequestItems
      };
    case SET_SCHEDULE_IMPACT_REQUEST_ITEM:
      return {
        ...state,
        scheduleImpactRequestItems: state.scheduleImpactRequestItems.map(
          (item) =>
            item.id === action.scheduleImpactRequestItem.id
              ? { ...item, ...action.scheduleImpactRequestItem }
              : item
        )
      };
    case SET_IS_IN_PREVIEW:
      return {
        ...state,
        isInPreview: action.isInPreview
      };
    case SET_ACTIVITIES_NO_APPLY_CHANGES:
      return {
        ...state,
        activitiesNoApplyChanges: action.activitiesNoApplyChanges
      };
    case SET_REQUEST_ID:
      return {
        ...state,
        requestId: action.requestId
      };
    default:
      return state;
  }
}

export default scheduleImpactRequestReducer;
